<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n'
import PsDefaultVue from '@/views/layouts/Default.vue'
import SavComponent from '@/views/components/SavComponent.vue'

const t = i18n.global.t
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
</script>


<template>
  <PsDefaultVue>

    <!-- ================= HERO CONTACT ================= -->
    <section class="pt-5 pb-0 bg-white">
      <div class="container ">
        <div class="row align-items-center">

          <!-- Image équipe -->
          <div class="col-lg-5 mb-4 mb-lg-0 text-center"
            :style="{ backgroundImage: `url(${VITE_ASSET_URL}assets/public/assets/img/topela_img_bg.png)`, backgroundSize: 'cover', backgroundPosition: 'top', backgroundRepeat: 'no-repeat' }">
            <img :src="VITE_ASSET_URL + 'assets/public/assets/img/topela_support_team.png'" alt="Équipe Topela"
              class="img-fluid position-relative" style="max-height:400px;" />
          </div>

          <!-- Texte -->
          <div class="col-lg-7 ps-5">
            <h1 class="fw-semibold mb-3">
              {{ t('w_txt_contact_page_heading') }}
            </h1>

            <p class="fs-4 mb-2" style="line-height: 1.5;">
              {{ t('w_txt_contact_page_subheading') }}
            </p>

            <p class="fs-4 mb-0" style="line-height: 1.6;">
              {{ t('w_txt_contact_page_paragraph') }}
            </p>
          </div>


        </div>
      </div>
    </section>

    <!-- ================= INTRO ================= -->
    <section class="py-5 bg-dark-blue ">
      <div class="container">
        <div class="row justify-content-center">

          <div class="col-lg-8 text-center">
            <h2 class="fw-semibold mb-3 text-white">
              {{ t('w_txt_contact_page_support_heading') }}
            </h2>
            <p class=" fs-5 mb-2 text-white">
              {{ t('w_txt_contact_page_support_subheading') }}
            </p>
            <p class=" small text-white">
              {{ t('w_txt_home_support_section_cta_subtext') }}

              <strong>{{ t('w_txt_home_support_section_cta_subtext_value') }}</strong>
            </p>
          </div>

        </div>
      </div>
    </section>

    <!-- ================= FORMULAIRE ================= -->
    <section id="contact-form" class="py-5">
      <div class="container">

        <div class="row justify-content-center">
          <div class="col-lg-8">

            <div class="bg-white rounded shadow-sm p-4 p-md-5">

              <SavComponent :id="'contact_page'" :source="'contact'" :intro="t('w_sav_intro_contact_form')"
                :btn-label="t('g_act_send')" :message-label="t('g_frm_plMessage')" :btn-classes="[
                  'btn-lg',
                  'rounded',
                  'btn-common',
                  'text-white',
                  'btn-effect',
                  'btn-text-visibility'
                ]" :btn-container-classes="[
                  'submit-button',
                  'd-flex',
                  'justify-content-center'
                ]" :outro="t('w_sav_outro_generic')" :btn-style="'font-size:18px !important;'" :message-input-rows="3"
                :hide-consent="false" :hide-phone="false" :hide-user-type="false" :hide-type-of-request="false"
                :is-for-contact-page="true" />

            </div>

          </div>
        </div>

      </div>
    </section>

    <section class="py-5 bg-dark-blue">
      <div class="container">

        <!-- Titre -->
        <div class="text-center mb-4">
          <h3 class="fw-semibold text-white">{{ t('w_txt_contact_page_faq_heading') }}</h3>
          <p class="text-white">
            {{ t('w_txt_contact_page_faq_subheading') }}
          </p>
        </div>

        <div class="accordion accordion-flush" id="faqTopela">

          <!-- FAQ 1 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq1">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1Content"
                aria-expanded="true">
                {{ t('w_txt_contact_page_faq_q1') }}
              </button>
            </h2>
            <div id="faq1Content" class="accordion-collapse collapse show">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a1') }}
                <strong>{{ t('w_txt_contact_page_faq_a1_value') }}</strong> {{ t('w_txt_contact_page_faq_a1_continued')
                }}
              </div>
            </div>
          </div>

          <!-- FAQ 2 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq2">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq2Content">
                {{ t('w_txt_contact_page_faq_q2') }}
              </button>
            </h2>
            <div id="faq2Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a2') }}
                <br />
                {{ t('w_txt_contact_page_faq_a2_continued') }}
              </div>
            </div>
          </div>

          <!-- FAQ 3 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq3">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq3Content">
                {{ t('w_txt_contact_page_faq_q3') }}
              </button>
            </h2>
            <div id="faq3Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a3') }}
                <strong>{{ t('w_txt_contact_page_faq_a3_value') }}</strong>{{ t('w_txt_contact_page_faq_a3_continued')
                }}
                <br />
                {{ t('w_txt_contact_page_faq_a3_final') }}
              </div>
            </div>
          </div>

          <!-- FAQ 4 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq4">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq4Content">
                {{ t('w_txt_contact_page_faq_q4') }}
              </button>
            </h2>
            <div id="faq4Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                <strong>{{ t('w_txt_contact_page_faq_a4_topela') }}</strong> {{ t('w_txt_contact_page_faq_a4_continued')
                }}
                <br></br>{{ t('w_txt_contact_page_faq_a4_price') }}
              </div>
            </div>
          </div>

          <!-- FAQ 5 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq5">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq5Content">
                {{ t('w_txt_contact_page_faq_q5') }}
              </button>
            </h2>
            <div id="faq5Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a5') }}
                <ul class="mt-2">
                  <li>{{ t('w_txt_contact_page_faq_a5_item1') }}</li>
                  <li>{{ t('w_txt_contact_page_faq_a5_item2') }}</li>
                  <li>{{ t('w_txt_contact_page_faq_a5_item3') }}</li>
                </ul>
                {{ t('w_txt_contact_page_faq_a5_continued') }}
              </div>
            </div>
          </div>

          <!-- FAQ 6 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq6">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq6Content">
                {{ t('w_txt_contact_page_faq_q6') }}
              </button>
            </h2>
            <div id="faq6Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a6') }}
              </div>
            </div>
          </div>

          <!-- FAQ 7 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq7">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq7Content">
                {{ t('w_txt_contact_page_faq_q7') }}
              </button>
            </h2>
            <div id="faq7Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a7') }}
                <ul class="mt-2">
                  <li>{{ t('w_txt_contact_page_faq_a7_item1') }}</li>
                  <li>{{ t('w_txt_contact_page_faq_a7_item2') }}</li>
                  <li>{{ t('w_txt_contact_page_faq_a7_item3') }}</li>
                </ul>
                {{ t('w_txt_contact_page_faq_a7_continued') }}
              </div>
            </div>
          </div>

          <!-- FAQ 8 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq8">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq8Content">
                {{ t('w_txt_contact_page_faq_q8') }}
              </button>
            </h2>
            <div id="faq8Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a8') }}
                <br />
                {{ t('w_txt_contact_page_faq_a8_continued') }}
              </div>
            </div>
          </div>

          <!-- FAQ 9 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="faq9">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq9Content">
                {{ t('w_txt_contact_page_faq_q9') }}
              </button>
            </h2>
            <div id="faq9Content" class="accordion-collapse collapse">
              <div class="accordion-body">
                {{ t('w_txt_contact_page_faq_a9') }}
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
    <section class="py-0 bg-info">
      <div class="container py-5">
        <div class="row d-flex align-items-center text-center text-md-start">
          <div class=" col-12 col-md-8 ">
            <h3 class=" fw-bold fs-1 h-style h2-style use-poppins display-4">{{ t('w_txt_contact_page_support_title') }}
            </h3>
            <p class=" fs-4" style="font-size: 16px">{{ t('w_txt_contact_page_support_subtitle') }}</p>
          </div>
          <div class="col-12 col-md-4">
            <a class="btn btn-dark bg-dark-blue rounded  btn-height btn-text-visibility d-block mx-auto mt-4"
              href="/contact/">
              {{ t('w_act_home_support_section_cta') }} </a>
            <p class="mb-0 small text-center">
              {{ t('w_txt_home_support_section_cta_subtext') }}

              <strong>{{ t('w_txt_home_support_section_cta_subtext_value') }}</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  </PsDefaultVue>
</template>

<style scoped>
.bg-dark-blue {
  background-color: #233648 !important;
}

.btn-text-visibility {
  font-size: 20px !important;
  font-weight: normal !important;
}
</style>
